// @flow

import _ from 'lodash';
import url from 'url';

import type { StackTrace } from 'tracekit';

export interface IStackTraceAnalyzer {
	isOuterScriptError (stacktrace: Array<StackTrace>): boolean,
}

export default class StackTraceAnalyzer implements IStackTraceAnalyzer {
	+_innerScriptHostNamePatterns: Array<string>;
	+_neutralStackTraceUrlValues: Array<string>;

	_getHostName: (stackTraceNode: StackTrace) => ?string;
	_isInnerHostName: (hostName: ?string) => boolean;
	_isNeutralStackTraceNode: (stackTraceNode: StackTrace) => boolean;

	constructor () {
		this._innerScriptHostNamePatterns = [
			'rgs\.ru$',
			'rgs\.ru\.(.*?)\.rgs-dev\.epam\.com$',
			'localhost$',
		];

		this._neutralStackTraceUrlValues = [
			'[native code]', // browser built-in function
			'HttpError: Internal Server Error',
			'HttpError: Bad Request',
			'cdn.appdynamics.com',
			'appdyn-prod-gw.rgs.ru',
			'api.flocktory.com',
			'connect.facebook.net',

			/*
			 * LKDMS-37403: Нельзя, чтоб ошибки в скриптах капчи, блокирующие процесс аутентификации, проглатывались.
			 * Иначе в случае ошибок люди говорят "на экране пусто, кнопки не работают", а нам сложно найти их ошибки.
			 * Нужно, чтоб клиент видел runtime код, который он сможет нам сообщить, а мы по коду найдем их проблему.
			 */
			'https://smartcaptcha.yandexcloud.net',
		];
	}

	isOuterScriptError (stacktrace) {
		if (_.isEmpty(stacktrace)) {
			return true;
		}

		const isInnerStackTrace = _.every(
			stacktrace,
			stacktraceNode => {
				const isNeutralCode = this._isNeutralStackTraceNode(stacktraceNode);

				if (isNeutralCode) {
					return true;
				}

				const stackTraceNodeHostName = this._getHostName(stacktraceNode);
				return this._isInnerHostName(stackTraceNodeHostName);
			}
		);

		return !isInnerStackTrace;
	}

	_getHostName = (stackTraceNode) => {
		if (!stackTraceNode) {
			return null;
		}

		let rawUrl = stackTraceNode.url;

		const isEvalCall = _.includes(rawUrl, 'eval at');

		if (isEvalCall) {
			// trying to extract url from string like 'eval at t (https://www.rgs.ru%), <anonymous>'
			var match = rawUrl.match(/\(([^)]+)\)/);

			if (!_.isEmpty(match) && match[1]) {
				rawUrl = match[1];
			}
		}

		return url.parse(rawUrl).hostname;
	}

	_isInnerHostName = (hostName) => _.some(
		this._innerScriptHostNamePatterns,
		innerHostNamePattern => hostName && hostName.search(innerHostNamePattern) >= 0
	)

	_isNeutralStackTraceNode = (stackTraceNode) => {
		return stackTraceNode
			&& stackTraceNode.url
			&& _.some(
				this._neutralStackTraceUrlValues,
				(x => x.toLowerCase() === stackTraceNode.url.toLowerCase()
					|| stackTraceNode.url.includes(x))
			);
	}
}